import React, { useState, useRef } from "react";
import classes from "./PageHeader.module.scss";
import RoundButton from "../../Buttons/RoundButton";
import ModalGroups from "../../ModalGroups";
import { useTranslation } from "react-i18next";
import { Chip } from "@mui/material";
import useFetch from "../../../hooks/useFetch";
import { UPDATE_USER_SHOTS } from "../../../constants/api";

interface Interface {
  title?: string;
  // not required
  className?: any;
  user?: any;
  subtitle?: any;
  chooseJourney?: any;
  setJourney?: (any: any) => void;
  username?: any;
  allusers?: any;
  btnPdfDownload?: any;
  textInfo?: any;
  btnText?: any;
  btnClick?: any;
  btnOptions?: any;
  btnDownloadFile?: string | null;
  btnTitle?: any;
  companyId?: any;
  isAdmin?: boolean;
  hasNewGroups?: () => void;
  setHasUserChangedGroup?: (boolean: boolean) => void;
}

export default function PageHeader({
  className = "",
  user = "",
  title = "",
  subtitle = null,
  chooseJourney = null,
  setJourney = (any: any) => {},
  username = "",
  allusers = "",
  btnPdfDownload = "",
  textInfo = null,
  btnText = "",
  btnClick = null,
  btnOptions = null,
  btnTitle = "",
  btnDownloadFile = null,
  companyId = null,
  isAdmin = false,
  hasNewGroups = () => {},
  setHasUserChangedGroup =(boolean: boolean) => {}
}: Interface) {
  const [shotAddMsg, setShotAddMsg] = useState("");
  const userInfos = useRef<any[]>([]);
  userInfos.current = user;
  const [, isLoadingShots, , fetchShots]: any = useFetch({
    autoInit: false,
  });
  const ModalAddGroups = (
    <ModalGroups
      className={classes.Dialog}
      textDialogPrimary={"Gerenciar Grupos"}
      textButton={"Gerenciar Grupos"}
      companyId={companyId}
      hasNewGroups={hasNewGroups}
      setHasUserChangedGroup={setHasUserChangedGroup}
    />
  );
  // Right Button
  const { t } = useTranslation();
  let _btn = null;
  if (btnDownloadFile)
    _btn = (
      <form method="get" action={btnDownloadFile} className={classes.RightArea}>
        <RoundButton
          small
          text={btnText ?? ""}
          title={btnTitle}
          type={"submit"}
        />
      </form>
    );
  else if (btnClick)
    _btn = (
      <div className={classes.RightArea}>
        {isAdmin ? ModalAddGroups : null}
        <RoundButton
          small
          text={btnText ?? ""}
          title={btnTitle}
          onClick={btnClick}
        />
      </div>
    );
  // const addJourney = (userInfos: any) => {
  //   const user_uid = userInfos.current[0].user_uid
  //   const company_uid = userInfos.current[0].company_uid
  //   const shots = userInfos.current[0].shots
  //   // const data = {
  //   //   user_uid: userInfos.current[0].user_uid,
  //   //   company_uid: userInfos.current[0].company_uid,
  //   // }
  //   setShotAddMsg("");
  //   if (shots >= 1) return alert("Erro ao adicionada jornada.");
  //   fetchShots({
  //     method: "POST",
  //     url: UPDATE_USER_SHOTS,
  //     data: {
  //       user_uid: user_uid,
  //       company_uid: company_uid,
  //     },
  //     onSuccess: () => {
  //       alert("Jornada adicionada com sucesso!");
  //     },
  //     onError: () => {
  //       alert("Erro ao adicionada jornada.");
  //     },
  //   });
  // };

  // Updating css from parent
  className += " " + classes.Header;
  const optionsJourney: any[] = [];
  const numberOfJourneys = new Array<number>(
    chooseJourney?.numberOfJourneys
  ).fill(1);
  numberOfJourneys?.map((journey: any, index: any) => {
    const opt = (
      <option value={index}>
        {t("global.journey")} {index + 1}
      </option>
    );
    optionsJourney.push(opt);
  });
  return (
    <header className={className}>
      <div className={classes.TitlesArea}>
        <h1 className={classes.Title}>{t(title)}</h1>
        {(subtitle || textInfo) && (
          <div className={classes.AreaInfo}>
            {subtitle && (
              <p className={classes.SubTitle}>
                {t(subtitle)} {username}
              </p>
            )}
            {chooseJourney?.showSelect && (
              <div className={classes.SelectJourneyArea}>
                {t("global.selec_other_journey")}
                {"  "}
                <select
                  onChange={(e) =>
                    setJourney(String(Number(e.target.value) + 1))
                  }
                  className={classes.SelectJourney}
                >
                  {optionsJourney}
                </select>
              </div>
            )}
            {textInfo && (
              <p className={classes.TextInfo}>
                <em>{t(textInfo)}</em>
              </p>
            )}
          </div>
        )}
        {companyId ? (
          <div className={classes.companyInfo}>
            {t("global.companyInfo")}:{" "}
            <Chip label={<h3>{companyId}</h3>} variant="outlined" />
          </div>
        ) : null}
      </div>
      {_btn}
      {allusers}
      {btnOptions}
      {btnPdfDownload}
    </header>
  );
}
